import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-bot-telegram',
  templateUrl: './layout-bot-telegram.component.html',
  styleUrls: ['./layout-bot-telegram.component.scss']
})
export class LayoutBotTelegramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
